import React, { useEffect, useState } from 'react'
import { Link } from "gatsby"
import { useForm } from 'react-hook-form';
import moment from "moment";

export default function FormCallMeBack({ formId, zipCode, locationEmail }) {

    const { register, handleSubmit } = useForm({
        mode: 'onSubmit',
        reValidateMode: 'onChange',
        defaultValues: {},
        resolver: undefined,
        context: undefined,
        criteriaMode: "all",
        shouldFocusError: true,
        shouldUnregister: false,
        shouldUseNativeValidation: true,
        delayError: undefined
    });

    const onSubmit = async (data, form) => {

        const formData = new FormData();
        formData.append("_timestamp", data._timestamp);
        formData.append("_sentfrom", data._sentfrom);
        formData.append("_location_id", document.getElementById('_location_id').value);
        formData.append("_location_email", document.getElementById('_location_email').value);
        formData.append("_zip", document.getElementById('_zip').value);
        formData.append("name", data.name);
        formData.append("phone", data.phone);
        formData.append("email", data.email);
        formData.append("checkbox", data.checkbox);

        const requestOptions = {
            method: 'POST',
            mode: 'no-cors',
            referrerPolicy: 'no-referrer',
            headers: {
                'Content-Type': 'application/json',
                'Access-Control-Allow-Origin': '*',
                'Access-Control-Allow-Headers': 'Origin, X-Requested-With, Content-Type, Accept',
            },
            body: formData
        };

        await fetch('https://hooks.zapier.com/hooks/catch/12346812/2i1l78j/', requestOptions).then(function (response) {
            if (response) {
                document.getElementById(formId + '_formSuccess').classList.remove('opacity-0', 'h-0', 'overflow-hidden')
                document.getElementById(formId + '_formSuccess').classList.add('opacity-100', 'h-full', 'overflow-visible')

                setTimeout(
                    function () {
                        document.getElementById(formId + '_formSuccess').classList.remove('opacity-100', 'h-full', 'overflow-visible')
                        document.getElementById(formId + '_formSuccess').classList.add('opacity-0', 'h-0', 'overflow-hidden')
                    },
                    5000
                )
                form.target.reset()
            }
            throw new Error('Network response was not ok.');
        }).catch(function (error) {
            console.log('There has been a problem with your fetch operation: ', error.message);
        });

    }

    return (
        <form onSubmit={handleSubmit(onSubmit, this)} className="max-w-3xl mx-auto grid grid-cols-1 md:grid-cols-2 gap-6 justify-center">
            <input
                type="hidden"
                value={moment().format("DD-MM-YYYY HH:mm:ss")}
                {...register("_timestamp", {})}
            />
            <input
                type="hidden"
                value={typeof window !== 'undefined' ? window.location.href : ''}
                {...register("_sentfrom", {})}
            />
            <input
                type="hidden"
                id="_location_id"
                {...register("_location_id", {})}
            />
            <input
                type="hidden"
                id="_location_email"
                value={locationEmail}
                {...register("_location_email", {})}
            />
            <input
                type="hidden"
                id="_zip"
                value={zipCode}
                {...register("_zip", {})}
            />
            <div className="form-group md:col-span-2">
                <label htmlFor="nameCMB">Name</label>
                <input
                    type="text"
                    id="nameCMB"
                    placeholder="z.B.: Max Mustermann"
                    {...register("name", { required: true, min: 3 })}
                />
            </div>
            <div className="form-group">
                <label htmlFor="phoneCMB">Telefon</label>
                <input
                    type="tel"
                    id="phoneCMB"
                    placeholder="z.B.: 04242 12345"
                    {...register("phone", { required: true, maxLength: 20 })}
                />
            </div>
            <div className="form-group">
                <label htmlFor="emailCMB">E-Mail-Adresse</label>
                <input
                    type="email"
                    id="emailCMB"
                    placeholder="z.B.: email@adresse.at"
                    {...register("email", { required: true, pattern: /^\S+@\S+$/i })}
                />
            </div>
            <div className="md:col-span-2 form-group-checkbox">
                <div className="input-wrapper">
                    <input
                        name="checkbox"
                        type="checkbox"
                        id="checkboxCMB"
                        {...register("checkbox", { required: true })}
                    />
                </div>
                <div className="label-wrapper">
                    <label htmlFor="checkboxCMB">
                        Ja, ich bin einverstanden, dass meine Daten gespeichert und zur Bearbeitung meines Anliegens weiterverwendet werden, und ich habe die <Link to="/datenschutzerklaerung" target="_blank" rel="noopener noreferrer">Datenschutzrichtlinien</Link> von REKORD gelesen und akzeptiert.
                    </label>
                </div>
            </div>
            <div className="md:col-span-2 opacity-0 h-0 overflow-hidden w-full " id={formId + '_formSuccess'}>
                <div className="w-full bg-rekord-lgreen text-green-700 border border-green-700 p-4 mt-6 rounded-lg" id={formId + '_formSuccess'}>
                    Vielen Dank für Deine Anfrage! Wir werden diese schnellstmöglich bearbeiten.
                </div>
            </div>
            <div className="md:col-span-2">
                <button className="btn btn-green">Rückruf anfordern</button>
            </div>
        </form>
    )

}
